module.exports = __webpack_public_path__ + "img/logo-servidoresmunicipales.166374b1.png";